import * as React from 'react';

import { ThumbsDownFilledIcon, ThumbsDownIcon } from '@coursera/cds-icons';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  selected?: boolean;
  onSelect(): void;
  onDeselect(): void;
};

const FeedbackDislike = ({ selected, onSelect, onDeselect }: Props) => {
  return (
    <div data-testid="dislike-component">
      {selected ? (
        <CoachIconButton
          size="small"
          data-testid="thumbs-down-filled-icon"
          aria-label={_t('Cancel #{coachLabel} message dislike', { coachLabel: 'Coach' })}
          tooltip={_t('Cancel dislike')}
          onClick={onDeselect}
          icon={<ThumbsDownFilledIcon color="default" size="small" />}
        />
      ) : (
        <CoachIconButton
          size="small"
          data-testid="thumbs-down-icon"
          aria-label={_t('Dislike #{coachLabel} message', { coachLabel: 'Coach' })}
          tooltip={_t('Dislike')}
          onClick={onSelect}
          icon={<ThumbsDownIcon color="default" size="small" />}
        />
      )}
    </div>
  );
};

export default FeedbackDislike;
